import React, { useEffect, useState } from 'react';
import { DatePicker, Form, Row, Select, Spin } from 'antd';
import DF from 'DisplayFramework';

import UtinaCard from 'components/UtinaCard';
import FormInput from 'components/FormInput';
import Value from 'components/Value';
import { PropThirdPartyResponse, getProposalById } from 'services/proposal';
import FormItem from 'antd/es/form/FormItem';
import { shouldUpdateCompare } from 'utils/utils2';
import ParListSelect from 'components/ParListSelect';
import { useQuery } from 'react-query';
import { isNil } from 'lodash';

export const TabUpdateTPMandateDate = ({
  objectid,
  form,
  dataInput,
  setSuccessful,
}: any) => {
  const [load, setload] = useState(false);

  const { data, refetch } = useQuery(
    ['getProposalById', objectid],
    () => getProposalById({ ctrid: objectid }).then((res) => res.data),
    {
      enabled: !isNil(objectid),
      staleTime: 60 * 1000 * 5,
    }
  );

  useEffect(() => {
    form?.setFieldsValue({
      event: 'tabUpadteDateMandat',
    });
  }, []);

  return (
    <DF.Provider pagcode="TabUpdateTPMandateDate">
      <Spin spinning={load}>
        <Form form={form} labelCol={{ span: 7 }} labelAlign="left">
          <UtinaCard
            style={{ height: '100%' }}
            level={5}
            lg={22}
            comcode="TabUpdateTPMandateDate"
          >
            <Row gutter={30}>
              <FormItem
                shouldUpdate={shouldUpdateCompare('thirdParties')}
                rules={[{ required: true }]}
                noStyle
              >
                {({ getFieldValue }) => {
                  return (
                    <FormInput name="tpidbeneficiary" col md={9}>
                      <Select
                        onSelect={(e) => {
                          let tps = data?.thirdParties?.find(
                            (tp: PropThirdPartyResponse) => tp.tpid === e
                          );
                          form.setFieldsValue({
                            tpbk:
                              tps?.bankAccountIn?.tpbankname +
                              ' ' +
                              tps?.bankAccountIn?.tpiban,
                            tppaymodein: tps?.tppaymodein,
                            tppaydelayin: tps?.tppaydelayin,
                            subentityid: tps?.tproleid,
                          });
                          form.setFieldValue('subentityid', tps?.tproleid);
                        }}
                        onClear={() => {
                          form.setFieldsValue({
                            tpbk: '',
                            tppaymodein: '',
                            tppaydelayin: '',
                            tpidbeneficiary: 0,
                          });
                        }}
                        allowClear
                      >
                        {data?.thirdParties?.map(
                          (tp: PropThirdPartyResponse) =>
                            tp.tprolecode === 'MFBENEF' && (
                              <Select.Option value={tp.tpid} key={tp.tpid}>
                                {tp.tpname}
                              </Select.Option>
                            )
                        )}
                      </Select>
                    </FormInput>
                  );
                }}
              </FormItem>
            </Row>
            <Row gutter={30}>
              <FormInput col md={9} name="tpbk">
                <Value />
              </FormInput>
              <FormInput col md={9} name="mandatedate">
                <DatePicker />
              </FormInput>
            </Row>
            <Row gutter={30}>
              <FormInput col md={9} name="tppaymodein">
                <ParListSelect parcode="PAYMODEIN" disabled />
              </FormInput>
              <FormInput col md={9} name="tppaydelayin">
                <ParListSelect parcode="PAYDELAYIN" disabled />
              </FormInput>
            </Row>
          </UtinaCard>
        </Form>
      </Spin>
    </DF.Provider>
  );
};
